import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import {addNotification} from "./notifications";

export const GET_STOCK_LIST_REQUEST = 'GET_STOCK_LIST_REQUEST';
export const GET_STOCK_LIST_SUCCESS = 'GET_STOCK_LIST_SUCCESS';
export const GET_STOCK_LIST_ERROR = 'GET_STOCK_LIST_ERROR';

export const GET_STOCK_REQUEST = 'GET_STOCK_REQUEST';
export const GET_STOCK_SUCCESS = 'GET_STOCK_SUCCESS';
export const GET_STOCK_ERROR = 'GET_STOCK_ERROR';

export const CREATE_STOCK_REQUEST = 'CREATE_STOCK_REQUEST';
export const CREATE_STOCK_SUCCESS = 'CREATE_STOCK_SUCCESS';
export const CREATE_STOCK_ERROR = 'CREATE_STOCK_ERROR';

export const UPDATE_STOCK_REQUEST = 'UPDATE_STOCK_REQUEST';
export const UPDATE_STOCK_SUCCESS = 'UPDATE_STOCK_SUCCESS';
export const UPDATE_STOCK_ERROR = 'UPDATE_STOCK_ERROR';

export const CLEAN_STOCK_LIST = 'CLEAN_STOCK_LIST';

// Get stock list
export function getStockList(query) {
    return async (dispatch) => {
        try {
            dispatch(getStockListRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/stock/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getStockListSuccess, getStockListError));
        } catch (err) {
            dispatch(utilsLib.response(err, getStockListError));
        }
    };
}

function getStockListRequest() {
    return {
        type: GET_STOCK_LIST_REQUEST,
        isFetching: true
    };
}

function getStockListSuccess (payload) {
    return {
        type: GET_STOCK_LIST_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getStockListError(errorMessage) {
    return {
        type: GET_STOCK_LIST_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get stock
export function getStock(stockId) {

    return async (dispatch) => {
        try {
            dispatch(getStockRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/stock/${stockId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getStockSuccess, getStockError));
        } catch (err) {
            dispatch(utilsLib.response(err, getStockError));
        }
    };
}

function getStockRequest() {
    return {
        type: GET_STOCK_REQUEST,
        isFetching: true
    };
}

function getStockSuccess (payload) {
    return {
        type: GET_STOCK_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}

function getStockError(errorMessage) {
    return {
        type: GET_STOCK_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create stock
export function createStock(stock, options) {
    return async (dispatch) => {
        try {
            dispatch(createStockRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/stock', {stock, options}, { headers: { 'Authorization': 'Bearer ' + token } });
            if (res.data.message === 'Finded stock, updated, not created.') {
                dispatch(utilsLib.response(res, updateStockSuccess, updateStockError));
            } else {
                dispatch(utilsLib.response(res, createStockSuccess, createStockError));
            }
        } catch (err) {
            dispatch(utilsLib.response(err, createStockError));
        }
    };
}

function createStockRequest() {
    return {
        type: CREATE_STOCK_REQUEST,
        isFetching: true
    };
}

function createStockSuccess (payload) {
    return dispatch => {
        // Create notification for create stock success
        dispatch(addNotification({
            message: 'Stock registrado correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_STOCK_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function createStockError(errorMessage) {
    return dispatch => {
        // Create notification for create stock error
        dispatch(addNotification({
            message: 'Error al registrar el stock',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_STOCK_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update stock
export function updateStock(stockId, stock = {}, options = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateStockRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/stock/${stockId}`, {stock, options}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateStockSuccess, updateStockError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateStockError));
        }
    };
}

function updateStockRequest() {
    return {
        type: UPDATE_STOCK_REQUEST,
        isFetching: true
    };
}

function updateStockSuccess (payload) {
    return dispatch => {
        // Create notification for update stock success
        dispatch(addNotification({
            message: 'Stock actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: UPDATE_STOCK_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}

function updateStockError(errorMessage) {
    return dispatch => {
        // Create notification for update stock error
        dispatch(addNotification({
            message: 'Error al actualizar el stock',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: UPDATE_STOCK_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean materials reducer
export function cleanStockList() {
    return {
        type: 'CLEAN_STOCK_LIST',
        isFetching: false,
        error: false,
        payload: []
    }
}




// WEBPACK FOOTER //
// ./src/actions/stock.js